export default {
    props: {
        enableImport: Boolean,
        importFormName: {
            type: String,
            default: 'default'
        },
        /**
         * 为空则取newRowSaveHolder
         */
        importSaveHolder: Object,

        disableExport: Boolean
    },
}
